import { render, staticRenderFns } from "./TasksHome.vue?vue&type=template&id=a2226ff2"
import script from "./TasksHome.vue?vue&type=script&lang=js"
export * from "./TasksHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports